import React from 'react';

import { getInviteCode } from '../../util/server-util';

export default function HiddenInviteCode() {
  const invite_code = getInviteCode();
  return invite_code ? <input type='hidden' name='invite_code' value={invite_code} /> : null;
}
